enum RoutePaths {
  ORDERS = '/',
  NEXT_ORDER = '/nextOrder',
  HISTORY = '/account/past-orders',
  MEAL_PREFERENCES = '/personalize',
  PLAN = '/account/plan',
  CREDITS_AND_PROMOTIONS = '/promotions',
  BILLING_AND_RECEIPTS = '/account/payments',
  CHANGE_PLAN = '/account/plan/change',
  FAVORITES = '/favorites',
  REFER_A_FRIEND = '/referral',
  ACCOUNT = '/account/settings',
  NOTIFICATIONS = '/notifications',
  NUTRITION = '/nutrition',
  HOW_IT_WORKS = '/how-it-works',
  PRODUCTS = '/products',
  MENU = '/meals',
  MYPLAN_SEARCH = '/meals/search',
  SEARCH = '/search',
  DOWNLOAD_APP = '/download-our-app',
  CONTENTTOCOMMERCE = '/c2c',
  REVIEW_CHALLENGE = '/review-challenge',
  MONTHLY_PLAN = '/monthly-plan',
  MEALS_LIST = '/productList',
  REACTIVATE = '/reactivate',
  UNITYPASS = '/unitypass',
  UNITYPASS_HUB = '/unitypass-hub',
  UNITYPASS_SETTINGS = '/unitypass-settings',
  UNITYPASS_JOIN = '/unitypass-join',
  TRIVIA_GAME = '/trivia-game',
  DYNAMIC_PAGE = '/dynamic/:slug',
  PRIVACY_SETTINGS = '/privacy-settings',

  // Core UX
  CORE_UX_ORDERS_HUB = '/orders-hub',
  ORDER_RATING = '/order-rating',
  CORE_UX_EXPRESS = '/express',
  ONBOARDING_HUB = '/onboarding-hub'
}

export { RoutePaths }
